import { useQuery } from "@tanstack/react-query";

import retailCore from "../core/retailShop.core";

export default function useRetailList() {
  return useQuery({
    queryKey: ["retailShop"],
    queryFn: retailCore.list,
  });
}
